import { FormItem } from 'vnetwork-ui'
import { ModalProps } from '@/types/shared'
import { useForm } from 'react-hook-form'
import { Button, Dialog } from 'vnetwork-ui'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { useTranslation } from 'react-i18next'
import { createCVSource } from '@/modules/Resume/services'
import { yupResolver } from '@hookform/resolvers/yup'
import createCVSourceValidate from './yup'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

export interface CreateCVSourceFormValues {
    cover_letter_source_name: string
}

export interface CreateCVSourceProps extends ModalProps {
    input: string
    onSuccessCreateCVSource: (
        data: Awaited<ReturnType<typeof createCVSource>>
    ) => void
}

const CreateCVSource: React.FC<CreateCVSourceProps> = ({
    onClose,
    open,
    input,
    onSuccessCreateCVSource,
}) => {
    const { t } = useTranslation()
    const { control, handleSubmit } = useForm<CreateCVSourceFormValues>({
        defaultValues: {
            cover_letter_source_name: input,
        },
        resolver: yupResolver(createCVSourceValidate as any),
    })

    const { mutateAsync, isPending } = useMutationWithHandler(
        {
            mutationFn: createCVSource,
        },
        {
            reactQueryKeys: QUERY_KEYS.RESUMES,
            successMessage: t('create-success'),
            onSuccess: (data) => {
                onSuccessCreateCVSource(data)
            },
        }
    )

    const handleSubmitForm = (data: CreateCVSourceFormValues) => {
        mutateAsync(data)
    }

    return (
        <Dialog
            onClose={onClose}
            open={open}
            title={t('create-cv-source')}
            closeOnClick={false}
            children={
                <form onSubmit={handleSubmit(handleSubmitForm)}>
                    <div>
                        <FormItem
                            control={control}
                            name="cover_letter_source_name"
                            type="textfield"
                            placeholder={t('name')}
                            label={t('name')}
                        />
                    </div>

                    <div className="flex items-center justify-end col-span-2 gap-2 mt-4">
                        <Button
                            disabled={isPending}
                            onClick={onClose}
                            variant="outlined"
                        >
                            {t('cancel')}
                        </Button>
                        <Button disabled={isPending} loading={isPending}>
                            {t('create')}
                        </Button>
                    </div>
                </form>
            }
        />
    )
}

export default CreateCVSource
